import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

const tickets = [
  {
    id: "1.0",
    detail: "Fire and Gas",
    response_SLA: "Route to 999",
    completion_SLA: "Route to 999",
  },
  {
    id: "1.1",
    detail: "Break down of the boiler",
    response_SLA: "Within 1 hour",
    completion_SLA: "Within 24 hour",
  },
  {
    id: "1.2",
    detail: "All damage to landlords",
    response_SLA: "Route to 999",
    completion_SLA: "Route to 999",
  },
  {
    id: "1.3",
    detail: "Building or Structure",
    response_SLA: "Route to 999",
    completion_SLA: "Route to 999",
  },
  {
    id: "1.4",
    detail: "Security issue as in lost key",
    response_SLA: "Route to 999",
    completion_SLA: "Route to 999",
  },
  {
    id: "1.5",
    detail: "Emergency Plumbing or Floods",
    response_SLA: "Route to 999",
    completion_SLA: "Route to 999",
  },
  {
    id: "1.6",
    detail: "Power supply",
    response_SLA: "Within 1 hour",
    completion_SLA: "WIthin 24 hours",
  },
];

const SuperTicketManagement = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [role, setRole] = useState(0);
  const [username, setUserName] = useState("");
  const [loading_script, setLoadingScript] = useState("");
  const [loading, setLoading] = useState(false);
  const [sectors, setSectors] = useState([]);

  const [rows, setRows] = useState([]);
  const [sortColumns, setSortColumns] = useState([]);
  const [selectedRows, setSelectedRows] = useState(() => new Set());

  useEffect(async () => {
    if (!location.state) {
      history.push("/");
    } else {
      const { role, username } = location.state;
      setRole(role);
      setUserName(username);
      const sectors = await Firebase.getAllSectors();
      setSectors(sectors);
    }
  }, [location]);

  // handlers
  const handleSelectSector = (sector) => {
    console.log("sector", sector);
  };

  return (
    <div id="page-container">
      <Header username={username} role={role} />
      <main id="main-container" className="super-planner-content">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && (
          <div>
            <div className="form-group row">
              <div className="col-3">
                Sector:
                <ReactSelect
                  // value={contentType}
                  onChange={handleSelectSector}
                  options={Object.keys(sectors).map((key) => ({
                    value: key,
                    label: sectors[key],
                  }))}
                  placeholder="Select Sector"
                ></ReactSelect>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default SuperTicketManagement;



// WEBPACK FOOTER //
// ./src/screens/SuperTicketManagement/index.js